const STATES = [
  {
    "name": "Alabama",
    "state": "AL"
  },
  {
    "name": "Alaska",
    "state": "AK"
  },
  {
    "name": "American Samoa",
    "state": "AS"
  },
  {
    "name": "Arizona",
    "state": "AZ"
  },
  {
    "name": "Arkansas",
    "state": "AR"
  },
  {
    "name": "California",
    "state": "CA"
  },
  {
    "name": "Colorado",
    "state": "CO"
  },
  {
    "name": "Connecticut",
    "state": "CT"
  },
  {
    "name": "Delaware",
    "state": "DE"
  },
  {
    "name": "District Of Columbia",
    "state": "DC"
  },
  {
    "name": "Federated States Of Micronesia",
    "state": "FM"
  },
  {
    "name": "Florida",
    "state": "FL"
  },
  {
    "name": "Georgia",
    "state": "GA"
  },
  {
    "name": "Guam",
    "state": "GU"
  },
  {
    "name": "Hawaii",
    "state": "HI"
  },
  {
    "name": "Idaho",
    "state": "ID"
  },
  {
    "name": "Illinois",
    "state": "IL"
  },
  {
    "name": "Indiana",
    "state": "IN"
  },
  {
    "name": "Iowa",
    "state": "IA"
  },
  {
    "name": "Kansas",
    "state": "KS"
  },
  {
    "name": "Kentucky",
    "state": "KY"
  },
  {
    "name": "Louisiana",
    "state": "LA"
  },
  {
    "name": "Maine",
    "state": "ME"
  },
  {
    "name": "Marshall Islands",
    "state": "MH"
  },
  {
    "name": "Maryland",
    "state": "MD"
  },
  {
    "name": "Massachusetts",
    "state": "MA"
  },
  {
    "name": "Michigan",
    "state": "MI"
  },
  {
    "name": "Minnesota",
    "state": "MN"
  },
  {
    "name": "Mississippi",
    "state": "MS"
  },
  {
    "name": "Missouri",
    "state": "MO"
  },
  {
    "name": "Montana",
    "state": "MT"
  },
  {
    "name": "Nebraska",
    "state": "NE"
  },
  {
    "name": "Nevada",
    "state": "NV"
  },
  {
    "name": "New Hampshire",
    "state": "NH"
  },
  {
    "name": "New Jersey",
    "state": "NJ"
  },
  {
    "name": "New Mexico",
    "state": "NM"
  },
  {
    "name": "New York",
    "state": "NY"
  },
  {
    "name": "North Carolina",
    "state": "NC"
  },
  {
    "name": "North Dakota",
    "state": "ND"
  },
  {
    "name": "Northern Mariana Islands",
    "state": "MP"
  },
  {
    "name": "Ohio",
    "state": "OH"
  },
  {
    "name": "Oklahoma",
    "state": "OK"
  },
  {
    "name": "Oregon",
    "state": "OR"
  },
  {
    "name": "Palau",
    "state": "PW"
  },
  {
    "name": "Pennsylvania",
    "state": "PA"
  },
  {
    "name": "Puerto Rico",
    "state": "PR"
  },
  {
    "name": "Rhode Island",
    "state": "RI"
  },
  {
    "name": "South Carolina",
    "state": "SC"
  },
  {
    "name": "South Dakota",
    "state": "SD"
  },
  {
    "name": "Tennessee",
    "state": "TN"
  },
  {
    "name": "Texas",
    "state": "TX"
  },
  {
    "name": "Utah",
    "state": "UT"
  },
  {
    "name": "Vermont",
    "state": "VT"
  },
  {
    "name": "Virgin Islands",
    "state": "VI"
  },
  {
    "name": "Virginia",
    "state": "VA"
  },
  {
    "name": "Washington",
    "state": "WA"
  },
  {
    "name": "West Virginia",
    "state": "WV"
  },
  {
    "name": "Wisconsin",
    "state": "WI"
  },
  {
    "name": "Wyoming",
    "state": "WY"
  }
];

export default STATES;
